(() => {
  const selector = '[data-heeposh-mrp-price]';

  const formatMoney = (amount) => {
    if (window.T4SThemeSP?.Currency?.formatMoney) {
      return window.T4SThemeSP.Currency.formatMoney(amount);
    }
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0
    }).format(amount / 100);
  };

  const renderMrp = (element, rawPrice) => {
    const price = Number(rawPrice);
    if (!element || !Number.isFinite(price) || price <= 0) return;

    const mrp = Math.ceil(price / 0.6 / 100) * 100;
    element.classList.add('t4s-mrp-price');
    element.innerHTML = `
      <ins class="t4s-mrp-current">${formatMoney(price)}</ins>
      <del class="t4s-mrp-compare">${formatMoney(mrp)}</del>
      <span class="t4s-mrp-discount">40% OFF</span>
    `;
  };

  const init = () => {
    const $ = window.jQuery_T4NT;
    if (!$) return;

    $(document)
      .off('variant:changed.heeposhMrp')
      .on('variant:changed.heeposhMrp', (event) => {
        const variant = event.currentVariant;
        const container = event.target;
        const element = container?.matches?.(selector)
          ? container
          : container?.querySelector?.(selector) || document.querySelector(selector);

        if (variant?.price != null) {
          renderMrp(element, variant.price);
        }
      });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
